import { useTrackPageBottomReached } from '@/utils/amplitude/analytics/pageBottomReached/trackPageBottomReached.analytics';

/**
 * An element that does not render visible content but will be treated as "visible" when it scrolls into view.
 * If your page uses query params to change content, the query params changing will allow this trigger to fire again.
 * e.g. If you're on search, scroll to the bottom of the page, it triggers only once on that page, even if you scroll up and down,
 * but if you go to the next page and scroll down, it will trigger again with the same behavior.
 */
export const TrackPageBottomReachedTrigger = () => {
    const bottomOfPageRef = useTrackPageBottomReached();

    // margin-top -22px to undo the 22px height this element has.
    // It cannot be sized at 0x0, otherwise the visibility of the fields won't be changed.
    return (
        <div
            className="mt-[-22px]"
            ref={bottomOfPageRef}
        >
            &nbsp;
        </div>
    );
};
